export default "__VITE_ASSET__BYwHLUij__"